import { RESET_CENSUS_PLANS } from './consts'

// Returns the census-plan slice to its default state (PD-30615). Nothing else
// clears it: REQUEST_CENSUS_PLANS does, but only the Individual branch of a
// scenario submit ever dispatches that, and componentWillUnmount's
// resetGroupQuoteRequests does not touch this slice. So an Individual search
// that failed left `generalError` set for the rest of the page's life -- a
// later Small Group search that SUCCEEDED still rendered the failure state and
// hid the Approve/Reject buttons, surviving navigation away and back.
export default function resetCensusPlanSearches() {
  return { type: RESET_CENSUS_PLANS }
}
